import { useEffect, useRef, type ReactNode, type CSSProperties } from 'react';
import styled from 'styled-components';
import ActionSheet from 'actionsheet-react';

interface IMobileModalPopupProps {
  open: boolean;
  bgColor?: string;
  closeModal: () => void;
  children?: ReactNode;
  style?: CSSProperties;
}

interface IModalContainerProps {
  bgcolor?: string;
}

const ModalContainer = styled.div<IModalContainerProps>`
  flex-direction: column;
  background-color: ${({ theme, bgcolor }) => bgcolor || theme.colors.white};
  flex: 1;
  overflow: hidden;
  z-index: 1001;
  transition: 0.3s;
  padding: 10px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const CloseContainer = styled.div`
  background: ${({ theme }) => theme.colors.grey};
  opacity: 0.3;
  border-radius: 50px;
  width: 113px;
  height: 6px;
  cursor: pointer;
`;

export function MobileModalPopup({
  open,
  bgColor,
  closeModal,
  children,
  style = {},
}: IMobileModalPopupProps) {
  const ref = useRef<{ open: () => void; close: () => void } | null>(null);

  useEffect(() => {
    if (open) {
      ref.current?.open();
    } else {
      ref.current?.close();
    }
  }, [open]);

  const handleClose = () => {
    ref.current?.close();
    closeModal();
  };

  return (
    <ActionSheet
      ref={ref}
      onClose={handleClose}
      sheetStyle={{
        overflow: 'hidden',
        zIndex: 10001,
        borderRadius: '0px',
      }}
    >
      <ModalContainer bgcolor={bgColor} style={style}>
        <Container>
          <CloseContainer onClick={handleClose} />
        </Container>
        {children}
      </ModalContainer>
    </ActionSheet>
  );
}
